import { PatientInfoGroups } from '../enums/patient-info-groups.enum';

export const PatientInfoGroupLabel = {
  [PatientInfoGroups.PRIMARY]: 'Basic info',
  [PatientInfoGroups.SECONDARY]: 'Additional info',
  [PatientInfoGroups.CONTACT]: 'Contact'
};
